var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElements4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7739 15C21.5232 15 22.1192 14.5285 22.6543 13.8691C23.7498 12.5194 21.9512 11.4408 21.2652 10.9126C20.5679 10.3756 19.7893 10.0714 18.9999 10M17.9999 8C19.3806 8 20.4999 6.88071 20.4999 5.5C20.4999 4.11929 19.3806 3 17.9999 3",
    stroke: "#2177FE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2259 15C2.47659 15 1.88061 14.5285 1.34548 13.8691C0.250028 12.5194 2.04861 11.4408 2.73458 10.9126C3.43191 10.3756 4.21052 10.0714 4.99994 10M5.49994 8C4.11923 8 2.99994 6.88071 2.99994 5.5C2.99994 4.11929 4.11923 3 5.49994 3",
    stroke: "#2177FE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08368 12.1112C7.0619 12.743 4.38286 14.0331 6.01458 15.6474C6.81166 16.436 7.6994 17 8.8155 17H15.1843C16.3004 17 17.1881 16.436 17.9852 15.6474C19.6169 14.0331 16.9379 12.743 15.9161 12.1112C13.52 10.6296 10.4797 10.6296 8.08368 12.1112Z",
    stroke: "#2177FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 4.5C15.4999 6.433 13.9329 8 11.9999 8C10.0669 8 8.49988 6.433 8.49988 4.5C8.49988 2.567 10.0669 1 11.9999 1C13.9329 1 15.4999 2.567 15.4999 4.5Z",
    stroke: "#2177FE",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements4);
export default __webpack_public_path__ + "static/media/elements (4).50e5ec5bde5e7ef1389555b52689d5ac.svg";
export { ForwardRef as ReactComponent };